/**
 * IpService.
 */

namespace Application.Services {
    export class IpService {
        public static $name: string = "ipService";

        /**
         * Transform an ip address to a decimal number
         * @param ip ip address
         * @return number
         */
        public ipToNumber(ip: string): number {
            let ipl = 0;
            ip.split(".").forEach(function(octet) {
                ipl <<= 8;
                ipl += parseInt(octet);
            });
            return (ipl >>> 0);
        };

        /**
         * Transform a decimal value to an ip address
         * @param ip number
         * @return ip address
         */
        public numberToIp(ip: number): string  {
            return ((ip >>> 24) + '.' +
              (ip >> 16 & 255) + '.' +
              (ip >> 8 & 255) + '.' +
              (ip & 255) );
        };

        /**
         * Calculates the number of ip addresses between 2 ips (including those 2)
         * @param ip minimum ip value
         * @param maxIp maximum ip value
         * @return number of ip addresses
         */
        public getNumberOfAddresses(ip: string, maxIp: string) {
            let nAddress: number = 0;
            if (ip && ip !== "") {
                // we calculate the difference between the 2 ips and add 1 to include the last ip
                nAddress = this.ipToNumber(maxIp) - this.ipToNumber(ip) + 1;
            }
            return nAddress;
        }

        /**
         * Increment an ip address value based on a parameter
         * @param ip ip to increment
         * @param increment increment value
         * @return new ip with the incremented value
         */
        public incrementIp(ip: string, increment: number = 1): string {
            let ipNumber: number = this.ipToNumber(ip);
            ipNumber+=increment;
            return this.numberToIp(ipNumber);
        }
    }
}